import MockProvider from '@core/GraphQLProvider/mockProvider';
import {mockError} from '../../util/MockUtils';

console.warn( '[LOAD NewsletterService mocks]' );
const provider = new MockProvider;

const Mutation = {
    newsletterSignup: () => true
    //newsletterSignup: mockError( 'newsletterSignup' )
};

provider.extendMocks( {Mutation} );